import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        const dest = location.pathname && location.pathname !== "/" ? location.pathname + location.search : "/studio";
        navigate(dest, { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location.hash, location.pathname, location.search, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#07080E]">
      <div className="text-center">
        <div className="w-14 h-14 rounded-full border-2 border-purple-500/30 border-t-purple-400 animate-spin mx-auto mb-4" />
        <p className="text-slate-400 font-mono text-sm">Authenticating with Vectra OS...</p>
      </div>
    </div>
  );
}
